import i18n from '../i18n.js';
import { formatFileSize } from '../utils.js';
export class ImageInfo {
  constructor(container) { this.container = container; this.render(); }
  render() {
    this.container.innerHTML =
      '<div class="image-info" id="image-info" style="display:none;">' +
      '<div class="image-info-item"><div class="image-info-label">' + i18n.t('image.info.dimensions') + '</div><div class="image-info-value" id="info-dimensions">&mdash;</div></div>' +
      '<div class="image-info-item"><div class="image-info-label">' + i18n.t('image.info.fileSize') + '</div><div class="image-info-value" id="info-filesize">&mdash;</div></div>' +
      '<div class="image-info-item"><div class="image-info-label">' + i18n.t('image.info.dpi') + '</div><div class="image-info-value" id="info-dpi">&mdash;</div></div>' +
      '<div class="image-info-item"><div class="image-info-label">' + i18n.t('image.info.dpi.target') + '</div><div class="image-info-value" id="info-targetdpi">300 DPI</div></div>' +
      '</div>';
    this.element = this.container.querySelector('#image-info');
    this.dimensionsEl = this.container.querySelector('#info-dimensions');
    this.filesizeEl = this.container.querySelector('#info-filesize');
    this.dpiEl = this.container.querySelector('#info-dpi');
  }
  show(im) {
    this.element.style.display = 'grid';
    this.dimensionsEl.textContent = im.width + ' × ' + im.height + ' px';
    this.filesizeEl.textContent = formatFileSize(im.file.size);
    if (im.dpi) { this.dpiEl.textContent = im.dpi + ' DPI'; this.dpiEl.className = 'image-info-value'; this.dpiEl.classList.add(im.dpi >= 300 ? 'dpi-good' : 'dpi-bad'); }
    else { this.dpiEl.textContent = '—'; this.dpiEl.className = 'image-info-value dpi-bad'; }
  }
  hide() { this.element.style.display = 'none'; }
  updateI18n() {
    var ls = this.container.querySelectorAll('.image-info-label');
    if (ls[0]) ls[0].textContent = i18n.t('image.info.dimensions');
    if (ls[1]) ls[1].textContent = i18n.t('image.info.fileSize');
    if (ls[2]) ls[2].textContent = i18n.t('image.info.dpi');
    if (ls[3]) ls[3].textContent = i18n.t('image.info.dpi.target');
  }
}
